/**
 * @generated SignedSource<<c55cc85675a91908879b5dd7ccccaf91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateWhatToSeeBlocksInput = {
  id: string;
  input: UpdateWhatToSeeBlockInput;
};
export type UpdateWhatToSeeBlockInput = {
  description?: string | null;
  name?: string | null;
};
export type WhatToSeeEditExtraMutation$variables = {
  id: string;
  input: ReadonlyArray<UpdateWhatToSeeBlocksInput>;
};
export type WhatToSeeEditExtraMutation$data = {
  readonly updateWhatToSeeBlocks: {
    readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeEditExtra_whatToSee" | "WhatToSeeSidebar_whatToSee">;
  } | null;
};
export type WhatToSeeEditExtraMutation = {
  response: WhatToSeeEditExtraMutation$data;
  variables: WhatToSeeEditExtraMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WhatToSeeEditExtraMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WhatToSee",
        "kind": "LinkedField",
        "name": "updateWhatToSeeBlocks",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WhatToSeeEditExtra_whatToSee"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WhatToSeeSidebar_whatToSee"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WhatToSeeEditExtraMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WhatToSee",
        "kind": "LinkedField",
        "name": "updateWhatToSeeBlocks",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 2147483647
              }
            ],
            "concreteType": "WhatToSeeBlockConnection",
            "kind": "LinkedField",
            "name": "blocks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WhatToSeeBlockEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WhatToSeeBlock",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": "blocks(first:2147483647)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Seo",
            "kind": "LinkedField",
            "name": "seo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2601e300fb457cb9038afb8ad2797e8f",
    "id": null,
    "metadata": {},
    "name": "WhatToSeeEditExtraMutation",
    "operationKind": "mutation",
    "text": "mutation WhatToSeeEditExtraMutation(\n  $id: ID!\n  $input: [UpdateWhatToSeeBlocksInput!]!\n) {\n  updateWhatToSeeBlocks(id: $id, input: $input) {\n    ...WhatToSeeEditExtra_whatToSee\n    ...WhatToSeeSidebar_whatToSee\n    id\n  }\n}\n\nfragment AddWhatToSeeBlockDialog_whatToSee on WhatToSee {\n  id\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment WhatToSeeBlocksFieldSections_blocksConnection on WhatToSeeBlockConnection {\n  edges {\n    node {\n      id\n      name\n      description\n    }\n  }\n}\n\nfragment WhatToSeeBlocksFieldSections_whatToSee on WhatToSee {\n  ...AddWhatToSeeBlockDialog_whatToSee\n}\n\nfragment WhatToSeeBlocksField_blocksConnection on WhatToSeeBlockConnection {\n  ...WhatToSeeBlocksFieldSections_blocksConnection\n}\n\nfragment WhatToSeeBlocksField_whatToSee on WhatToSee {\n  ...WhatToSeeBlocksFieldSections_whatToSee\n}\n\nfragment WhatToSeeEditExtra_whatToSee on WhatToSee {\n  id\n  blocks(first: 2147483647) {\n    edges {\n      node {\n        id\n        name\n        description\n      }\n    }\n    ...WhatToSeeBlocksField_blocksConnection\n  }\n  ...WhatToSeeBlocksField_whatToSee\n}\n\nfragment WhatToSeeSidebar_whatToSee on WhatToSee {\n  seo {\n    slug\n    id\n  }\n  ...EntitySidebar_entity\n}\n"
  }
};
})();

(node as any).hash = "3f8ced64923bfcbe81eb6cd3e63c578a";

export default node;
